import Vue from 'vue';
import App from './App.vue';
import router from './router';
import {Vue2Storage} from 'vue2-storage'
import { firestorePlugin } from 'vuefire'
import VueSignaturePad from 'vue-signature-pad';


import Ionic from '@ionic/vue';
import '@ionic/core/css/ionic.bundle.css';
import './registerServiceWorker'


Vue.use(VueSignaturePad);
Vue.use(firestorePlugin)
Vue.use(Ionic);


Vue.config.ignoredElements = [/^ui-/];
Vue.config.ignoredElements = [/^ion-/];
// Vue.prototype.$func = func;
// Vue.config.ignoredElements = [/^ion-select-/];
Vue.use(Vue2Storage, {
  prefix: 'app_',
  driver: 'local',
  ttl: 60 * 60 * 24 * 1000 // 24 hours
})

// Vue.config.ignoredElements = [/^ion-/];
Vue.config.productionTip = false;


new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

